import { COLOR_TYPES, qrCodeDotsTypeOptions } from "routes/qrcodes/qr_design/DotSettingsSection";

const QR_DESIGN_WIDTH = 350;
const QR_DESIGN_HEIGHT = 350;
const INNOVID_URL = "https://www.innovid.com";
const CROSS_ORIGIN = "anonymous";
const QR_OPTIONS = {
	typeNumber: "0",
	mode: "Byte",
	errorCorrectionLevel: "H",
};
const SQUARE_TYPE = "square";
const BLACK_COLOR = "#000000";
const WHITE_COLOR = "#ffffff";
const ROUND_BACKGROUND_OPTIONS = 0;

export const defaultQrDesignValues = {
	name: "",
	details: {
		shape: SQUARE_TYPE,
		data: INNOVID_URL,
		width: QR_DESIGN_WIDTH,
		height: QR_DESIGN_HEIGHT,
		qrOptions: QR_OPTIONS,
		cornersSquareOptions: {
			type: SQUARE_TYPE,
		},
		cornersDotOptions: {
			type: SQUARE_TYPE,
		},
		imageOptions: {
			hideBackgroundDots: true,
			crossOrigin: CROSS_ORIGIN,
			imageSize: 0.5,
			margin: 0,
		},
		backgroundOptions: {
			round: ROUND_BACKGROUND_OPTIONS,
			color: WHITE_COLOR,
		},
		stroke: {
			width: 0,
			color: BLACK_COLOR,
		},
		margin: 0,
		dotsOptions: {
			type: qrCodeDotsTypeOptions[0].value,
		},
	},
	logo: {
		filename: null,
		base64: null,
	},
	dotsColorType: COLOR_TYPES.SOLID,
	solid: {
		color: "#000000",
	},
	gradient: {
		type: "linear",
		rotation: 0,
		colorStops: [
			{ offset: 0, color: "#000000" },
			{ offset: 1, color: "#000000" },
		],
	},
};
